import type { PopularTag, Tag, TagCategoryStat, TagPayload } from "../types";
import { api } from "./core";

export const tagsApi = {
  tags: (groupId: string) => api<Tag[]>("/tags", { groupId }),
  popularTags: (groupId: string, categoryId?: string, limit = 8) => {
    const params = new URLSearchParams();
    if (categoryId) params.set("category_id", categoryId);
    params.set("limit", String(limit));
    return api<PopularTag[]>(`/tags/popular?${params.toString()}`, { groupId });
  },
  createTag: (groupId: string, payload: TagPayload) =>
    api<Tag>("/tags", { method: "POST", body: JSON.stringify(payload), groupId }),
  updateTag: (groupId: string, id: string, payload: TagPayload) =>
    api<Tag>(`/tags/${id}`, { method: "PATCH", body: JSON.stringify(payload), groupId }),
  deleteTag: (groupId: string, id: string) =>
    api<void>(`/tags/${id}`, { method: "DELETE", groupId }),
  restoreTag: (groupId: string, id: string) =>
    api<Tag>(`/tags/${id}/restore`, { method: "POST", groupId }),
  reorderTags: (groupId: string, tagIds: string[]) =>
    api<Tag[]>("/tags/reorder", { method: "POST", body: JSON.stringify({ tag_ids: tagIds }), groupId }),
  debugTagCategoryStats: (groupId: string) =>
    api<TagCategoryStat[]>("/debug/tag-category-stats", { groupId }),
};
